<ng-container>
  <mat-toolbar color="primary">
    <div class="tw-flex tw-flex-col tw-justify-start tw-items-start tw-w-full">
      <div class="tw-text-lg tw-font-bold">{{header}}</div>
      @if (lastUpdate) {
        <span class="tw-text-xs tw-opacity-60 tw-whitespace-normal">Updated: {{lastUpdate | date: 'YYYY-MM-dd HH:mm:ss'}} ({{lastUpdateRelative}})</span>
      }
      @else {
        <span class="tw-text-xs tw-opacity-60 tw-whitespace-normal">
          @if (isWorking) {
            Loading...
          } @else {
            No data
          }
        </span>
      }
    </div>

    <!-- Refresh button -->
    <button mat-icon-button (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>

    <!-- Options -->
    <button mat-icon-button [matMenuTriggerFor]="options">
      <mat-icon>more_vert</mat-icon>
    </button>

    <!-- Options menu -->
    <mat-menu #options="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="refreshRates">
        <span>Refresh every ...</span>
      </button>
      <button (click)="reset()" mat-menu-item>
        <span>Reset</span>
      </button>
      <mat-divider *ngIf="actions"></mat-divider>
      <button *ngFor="let action of actions" (click)="action.run()" mat-menu-item><span>{{action.name}}</span></button>
    </mat-menu>

    <!-- Refresh rates 'dropdown' -->
    <mat-menu #refreshRates="matMenu">
      <button (click)="setRefreshRate(refreshRate)" *ngFor="let refreshRate of refreshRateOptions"
        mat-menu-item>{{refreshRate.text}} <span *ngIf="refreshRate == refreshRateOption">
          <mat-icon>done</mat-icon>
        </span></button>
    </mat-menu>
  </mat-toolbar>

  <!-- Widget content -->
  <ng-container *ngIf="!isWorking">
    <div class="widgetContent">
      <ng-content></ng-content>
    </div>
  </ng-container>

  <!-- Spinner -->
  <ng-container *ngIf="isWorking">
    <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-min-h-20">
      <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    </div>
  </ng-container>
</ng-container>